import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InventoryColInfoService {
      constructor() { }

      orderStatusColInfo(){
          return `
          To update order statuses, use the Refresh Blotter button above. Note: if you navigate away from this screen, when you return the statuses will be updated automatically.
          `
      }

      amtTypeColInfo(){
          return `
          <div class='block'>The amount type controls the form in which the trade is sent to SAC for execution.</div>
          <ul>
            <li>For mutual fund buys, the amount type will be set to dollars.</li>
            <li>For mutual fund sales, the amount type will default to dollars but can be changed to shares. Sales that represent over 95% of the holding value will be automatically set to shares.</li>
            <li>Equity trades are always set to shares.</li>
            <li>Trades in all other security types will always be set to dollars.</li>
          </ul>
          `
      }

      shrQtyColInfo(){
        return `
        <div class='block'>The share quantity is calculated by dividing the approved order amount by the quote currently displayed for the security.
        Note: If you submit this order, a newer quote might be available and will be used to re-calculate the share quantity before sending for execution.
        </div>
        <div>* The number of shares that will be sold is the number of shares shown in the share quantity column. If the account holds additional shares due to a recent purchase or transfer, these shares will not be sold.
        </div>
        `
    }

    priceColInfo() {
      return `
        <div class='block'><sup class="inv-grid-col-price-sup">&#8224;</sup>Last trade, bid, ask, and midpoint limit prices are dynamic values that are updated each time the blotter is refreshed - as long as the order status is approved, validated, or overridden. Orders are submitted with the latest value at the time of submission.
        </div>
        `
    }

    notHeldColInfo(){
        return `
        <div class='block'>Not Held: A market or limit order that gives the broker or floor trader both time and price discretion to attempt to get the best possible price.
        </div><div class='block'>
        To create or edit a Not Held order, open the Trade Instruction pop-up window, by clicking in the checkbox.
        </div><div class='block'>
        Not Held orders will show a selected checkbox. Regular orders will show an empty checkbox.
        </div><div class='block'>
        To view details of a Not Held order that is no longer editable, click in the shaded checkbox.
        </div><div>
        Regular orders that are no longer editable are represented by a hyphen in the Not Held column.
        </div>
        `
    }

    quoteColInfo(){
        return `
        <div>This is the market price as of the most recent blotter refresh. The quote will be updated with each blotter refresh as long as the order status is: approved, validated, or overridden. Where you see a double asterisk (**), iRebal is using external holdings share price specified in the security master.
        </div>
        `
    }

    avgVolColInfo(){
        return `
        <div>The 10 day average trading volume, as of the prior business day, is displayed for all equity orders. The order amount as a percentage of the 10 day average trading volume is displayed on all block orders. This percentage is calculated at the time the block order is created and does not re-calculate based on price fluctuations.
        </div>
        `
    }

    ticketTypeInfo(){
        return `
            <div class='block'>
                A: Automatically<br/>
                E: Electronically<br/>
                M: Manually
            </div>
            <div>
                A: The order was generated as part of automated rebalancing. iRebal will submit it automatically.<br/>
                E: The security can be traded electronically directly from the blotter. (Only equities and mutual funds can be traded electronically using iRebal.)<br/>
                M: The order must be traded manually.
            </div>
            `
    }
}
